import { stronaStudentaActionTypes } from '.';

type tabId = DynamicTabComponent['id'];

export const init = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.INIT,
  payload: { tabId /* przedmiotId */ },
} as const);
export const getLeftPanelData = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.GET_LEFT_PANEL_DATA_START,
  payload: { tabId },
} as const);
export const getData = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.GET_DATA_START,
  payload: { tabId },
} as const);
export const getDataNextPage = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.GET_DATA_NEXT_PAGE_START,
  payload: { tabId },
} as const);
// export const syncDataWithCache = (tabId: tabId) => ({
//   type: stronaStudentaActionTypes.SYNC_DATA_WITH_CACHE_START,
//   payload: { tabId },
// } as const);
export const getColumnsConfig = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.COLUMNS_GET_CONFIG_START,
  payload: { tabId },
} as const);
export const saveColumnsUserSetup = (tabId: tabId, selectedColumns: SelectedColumns) => ({
  type: stronaStudentaActionTypes.COLUMNS_SAVE_USER_SETUP_START,
  payload: { tabId, selectedColumns },
} as const);
export const getRecordDetails = (tabId: tabId, recordId: string | number, refresh: boolean) => ({
  type: stronaStudentaActionTypes.RECORD_GET_DETAILS_START,
  payload: { tabId, recordId, refresh },
} as const);
export const refreshData = (tabId: tabId) => ({
  type: stronaStudentaActionTypes.REFRESH_DATA_START,
  payload: { tabId },
} as const);
export const refreshSelectedData = (tabId: tabId, recordsToRefresh: ViewDataSet['selected']) => ({
  type: stronaStudentaActionTypes.REFRESH_SELECTED_DATA_START,
  payload: { tabId, recordsToRefresh },
} as const);
